<template>
  <div>
    <download-excel
      style="width: 100px"
      :data="data"
      :fields="json_fields"
      type="xls"
      name="砍价订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template> -->
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate">
        <a
          href=""
          v-on:click.prevent="topage('/home/exchangeOrder/orderDetails')"
          >订单详情</a
        >
        <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >确认领取</a
        >
        <a v-on:click.prevent="showModal">取消订单</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { financialList } from "@/api/orderApi";
import { runningWaterSeach } from "@/api/homeApi.js";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "财务单号",
    align: "center",
    dataIndex: "orderNo",
  },
  {
    title: "财务类型",
    dataIndex: "financeTypeStr",
    align: "center",
    sorter: true,
    scopedSlots: { customRender: "financeTypeStr" },
  },
  {
    title: "收支类型",
    dataIndex: "moneyAddStr",
    align: "center",
    // sorter: true,
    scopedSlots: { customRender: "moneyAddStr" },
  },
  {
    title: "提交金额",
    dataIndex: "moneyChange",
    align: "center",
    // sorter: true,
    scopedSlots: { customRender: "moneyChange" },
  },
  {
    title: "落地金额",
    dataIndex: "moneyClean",
    align: "center",
    // sorter: true,
    scopedSlots: { customRender: "moneyClean" },
  },
  {
    title: "佣金金额",
    dataIndex: "moneyRate",
    align: "center",
    // sorter: true,
    scopedSlots: { customRender: "moneyRate" },
  },
  // {
  //   title: "交易方式",
  //   dataIndex: "name",
  //   sorter: true,
  //   width: "15%",
  //   // scopedSlots: { customRender: "operate" },
  // },
  {
    title: "交易状态",
    dataIndex: "financeStatus",
    align: "center",
    sorter: true,
    scopedSlots: { customRender: "financeStatus" },
  },
  {
    title: "奖罚原因",
    dataIndex: "name",
    align: "center",
    sorter: true,
    scopedSlots: { customRender: "" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {},
      json_fields: {
        编号: "objId",
        财务单号: "uid",
        财务类型: "phone",
        收支类型: "headImg",
        提交金额: "nickName",
        落地金额: "usableStr",
        佣金金额: "areaId",
        交易状态: "regionRecord",
        奖罚原因: "lastLogin",
        创建时间: "signShopType",
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getFinancialListData();
  },
  props: ["formInline"],
  methods: {
    // 财务流水订单列表
    getFinancialListData() {
      financialList(10, 1).then((res) => {
        console.log(res);
        this.data = res.data;
        console.log(this.data);
      });
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    query() {
      runningWaterSeach(
        10,
        1,
        this.formInline.orderNo,
        this.formInline.beginTime,
        this.formInline.endTime
      ).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/financialManagement/runningWater/runningWaterContent.vue